import { render, staticRenderFns } from "./NewTransaction.vue?vue&type=template&id=ebcabf10"
import script from "./NewTransaction.vue?vue&type=script&lang=js"
export * from "./NewTransaction.vue?vue&type=script&lang=js"
import style0 from "./NewTransaction.vue?vue&type=style&index=0&id=ebcabf10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports